import React, { useEffect, useState } from 'react';
import ReferAndEarn from './ReferAndEarn';
import { ReferWrapper } from './styles';
import {
  getContentSchemaFromContentFul,
  getInstapointHistory
} from '../../redux/actions/common/common-action';
import isEmpty from 'lodash/isEmpty';
import { getReferralCMSSpecificToCountry } from '../../utils/cmsData/filterCntentCountrySpecific';
import { CONTENTFUL_SCHEMA_KEYS, REFERRAL_BASE_URL } from '../../utils/constants';
import { useSelector, useDispatch } from 'react-redux';
import { History, ReferEarnProps } from './interface';
import { activateLoader, disableLoader } from '../../redux/actions/ui-trigger/ui-trigger-action';
import { getInstaPoints } from '../../redux/actions/instapoints/instapoints-action';
import { selectIPBalance, selectUserSession } from '../../redux/selectors';
import { AppDispatch } from '../../store.type';

const ReferEarn: React.FC<ReferEarnProps> = (props): React.ReactElement => {
  const [cmsReferalSchema, setCmsReferalSchema] = useState<Record<string, unknown>>({});
  const [historyData, setHistoryData] = useState<History[]>([]);
  const userSession = useSelector(selectUserSession);
  const ipBalance = useSelector(selectIPBalance);
  const isAmazeUser = userSession?.is_amaze_customer;
  const isRemittanceUser = userSession?.is_remittance_transaction_initiated;
  const dispatch = useDispatch<AppDispatch>();

  const fetchData = async () => {
    dispatch(activateLoader());
    const contentFulSchema = await getContentSchemaFromContentFul(
      CONTENTFUL_SCHEMA_KEYS['REFER_N_EARN']['CONTENT_TYPE'],
      CONTENTFUL_SCHEMA_KEYS['REFER_N_EARN']['TITLE']
    );
    if (!isEmpty(contentFulSchema)) {
      const countrySpecific = getReferralCMSSpecificToCountry(
        contentFulSchema,
        userSession?.country_code,
        isAmazeUser,
        isRemittanceUser
      );
      setCmsReferalSchema(countrySpecific);
    }
    dispatch(disableLoader());
  };

  const getReferHistory = async () => {
    dispatch(activateLoader());
    try {
      const referralResponse = await getInstapointHistory({ referral_instapoint: true });
      const updatedAll = referralResponse?.data?.data?.referral_activity;
      setHistoryData(updatedAll);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
    dispatch(disableLoader());
  };

  useEffect(() => {
    fetchData();
    getReferHistory();
    dispatch(getInstaPoints());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const url = `${REFERRAL_BASE_URL}${userSession?.referral_code}`;

  return (
    <ReferWrapper>
      <ReferAndEarn
        countryCode={userSession?.country_code}
        referandEarnSchema={cmsReferalSchema}
        initialReferralInstapoint={ipBalance?.initial_referral_instapoint}
        redemptionValue={ipBalance?.redemption_value}
        transactionReferralInstapoint={ipBalance?.transaction_referral_instapoint}
        url={url}
        historyData={historyData}
      ></ReferAndEarn>
    </ReferWrapper>
  );
};

export default ReferEarn;
